import React, { Component } from 'react';
import Moment from 'react-moment';
import { Form, Field} from 'react-final-form';
import Modal from '../../widgets/Modal';
import Confirm from '../../widgets/Confirm';
import {connect} from 'react-redux';
import {CardHalfVertical} from '../../widgets/Cards';
import { fetchPhotoExternal} from '../../../actions';
import { fetchPhotoMacros, fetchPhotoMacro, editPhotoMacro, newPhotoMacro, deletePhotoMacro} from '../../../actions';
import { fetchShowMacro } from '../../../actions';




class PhotoMacro extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showDelete : false,
            showEnlarge: false,
            newForm : true,
            record : null,
            selectedFile :null,
            fileName :"",
            isFilePicked: false, 
            initPhoto : false,
            photoDate:"",
            photoCaption:"",
            photoData:"",
        };

    this.changeHandler = this.changeHandler.bind(this);   
    };

    //Initial Rendering
    // componentDidMount() {
    //     if (this.props.selectedPhoto_External !== null){
    //         var extID = this.props.selectedPhoto_External._id;
    //         this.props.fetchPhotoMacros(extID);
    //         this.setState({initPhoto:true});
    //     }
    // }

    componentDidUpdate(prevProps) {
    
      
        if (this.props.selectedPhoto_External !== null  && this.props.selectedPhoto_External !== prevProps.selectedPhoto_External){
            var extID = this.props.selectedPhoto_External._id;
            this.props.fetchPhotoMacros(extID);
            this.setState({initPhoto:true})
        }
    }

    componentWillUnmount() {
        this.setState({initPhoto:false});
        
    }

    // RenderEnlarge
    renderEnlarge() {
        const caption = this.state.photoCaption;
        const date = this.state.photoDate;
        const photo = this.state.photoData;

        const imageData = () => {
            return (
                <div style={{display:'grid', gridTemplateRows:'600px auto', gridGap:'30px', margin:'30px'}}>
                <div style={{ textAlign :"center"}}>
                    <img src={photo} alt="none" style={{height:"600px"}}/>
                </div>
                <div style={{boxShadow:"0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", padding:'10px', borderRadius:'5px'}}>
                    {caption}
                </div>
                </div>
            )
        }

        const imageDate = () => {
            return (
                <div style={{ textAlign :"center"}}>
                    <Moment format='DD MMM YYYY'>{date}</Moment>
                </div>
            )
        }
        
        return (
            <Modal 
                height='800px'
                width='1000px'
                open={this.state.showEnlarge} 
                title={imageDate()}
                data=""
                content={imageData()}
                onDismiss={() => this.setState({showEnlarge: false, record: null})}
            />
        )
    }

    //sorting list by date
    compareDate(a, b) {

        var key1 = a.date;
        var key2 = b.date;
    
        if (key1 > key2) {
            return -1;
        } else if (key1 === key2) {
            return 0;
        } else {
            return 1;
        }
    }

   // Render content
    renderPhotoList() {
        if (this.state.initPhoto === true) {


            var list = this.props.photo_macros;
            var sortedList = list.sort(this.compareDate);
    
            return sortedList.map(item =>  {

                    const rowButton = () => {
                        var permit = this.props.selectedPermission.permission[0].chronicdisease;
                        if (permit === "View only") {
                            return null;
                        } else { 
                            return (
                                <>
                                <button onClick={() => this.setState({showModal: true, newForm: false, record: item._id})} style={{float:'right'}} className='tableEdit'><i className="far fa-edit"></i></button>
                                <button onClick={() => this.setState({showDelete: true, record: item._id})} style={{float:'right'}} className='tableDelete'><i className="fas fa-trash"></i></button>
                                </>
                            )
                        }  
                    }
                    return (
                    <div id={item.filename} onClick={this.selectRow} className='container'>
                        <div className='content' onClick={() => this.setState({showEnlarge: true, photoDate:item.date, photoCaption:item.caption, photoData:item.photo})}>
                            <div>
                                <Moment format='DD MMM YYYY'>{item.date}</Moment>
                                {rowButton()}
                            </div>
                            <p></p>
                            <div style={{ textAlign :"center"}}>
                                <img src={item.photo} alt="none" style={{height:"200px"}}/>
                            </div>
                            <div>  
                            <p></p>
                          
                            {item.caption}
                            </div>
                        </div>
                    </div>
                    )
            });   
        }   
    }

    buttons() {

        var permit = this.props.selectedPermission.permission[0].photo;
        if (permit === "View only") {
            return null
        } else { 
            return  <button onClick={() => this.setState({showModal: true, newForm: true, record: null})} style={{width:'96%', fontSize:'14px'}} className='btnew'>Add</button>
        }  
        
    }
    render() {
        return (
                <CardHalfVertical title='Macro'>
                    {this.buttons()}
                    <div className="timeline">
                        
                        
                        {this.renderPhotoList()}
                       
                        {this.renderModalBox()}
                        {this.renderDeleteBox()}
                        {this.renderEnlarge()}
                    
                      
                    </div>
                </CardHalfVertical>
        )
    }

    //on change file button
    changeHandler = (event) => {
        this.setState({
            selectedFile: event.target.files[0], 
            isFilePicked:true,
            fileName: event.target.files[0].name
            });
    };   
    
    //Update or New Form Pop Up

    renderModalBox() {
        const record = this.state.record;
        if (record !== null) {
           this.props.fetchPhotoMacro(record);
        }

        const photo_Form = (e) => {
            const required = value =>(value ? undefined : 'Required');

            const handleSubmit = (formValues) => {
            
                const form = formValues;
                form['patientId'] = this.props.patient._id;
                form['practiceID'] = 5;
                form['externalID'] = 4;
                form['provider'] = "Dr Rindacure";
          
                let formData = new FormData();
                var uploadedPhoto = this.state.selectedFile;
               
                var newFileName = this.props.selectedPhoto_External._id + "macrofrom" + this.props.patient._id + "taken" + new Date().getTime();
              
                formData.append("patientId", this.props.patient._id);
                formData.append('practiceID', 5);
                formData.append('externalID', 4);
                formData.append('provider', "Dr findatu");
                formData.append('caption',form.caption);
                formData.append('sessionId',this.props.selectedPhoto_External._id);
                formData.append('filename', newFileName);
                formData.append('photo', uploadedPhoto, newFileName);

                for(let [name, value] of formData) {
                console.log(`${name} = ${value}`); 
                }

                this.props.newPhotoMacro(formData);

                // const photo_externalId = form._id;
                // if (photo_externalId === undefined) {
                //     this.props.newPhotoMacro(form);
                // } else {
                //     this.props.editPhotoMacro(form, photo_externalId);
                // }
                this.setState({showModal :false, newForm : true,record : null,});
            }
            return (
                <Form 
                    onSubmit = {handleSubmit} 
                    render = {({ handleSubmit, pristine, form, values, submitting }) => {
                    return   (
                            <form onSubmit={handleSubmit} encType="multipart/form-data">

                                
                                    <Field name="caption" component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Caption</label>
                                                <input {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )}
                                    </Field>
                                    <Field name="photo" component='input' placeholder='' onChange={this.changeHandler}>
                                        {({input, meta, placeholder, onChange}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Photo</label>
                                                <input {...input} placeholder={placeholder} type='file' onChange={onChange}/>
                                               
                                            </div>
                                        )}
                                    </Field>

                                    <div className='modalButton'>
                                        <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                        <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                        <button onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                                    </div>
                                  
                            </form>
                        )
                    }}
                />
            )
        }   

        return (
            <Modal 
                height='300px'
                width='300px'
                open={this.state.showModal} 
                title='Macro'
                data={this.state.record}
                content={photo_Form()}
                onDismiss={() => this.setState({showModal: false, record: null})}
            />
        )
    }

    //Delete confirmation pop up
    renderDeleteBox() {

        const handleDelete = () => {
            this.props.deletePhotoMacro(this.state.record);
            this.setState({showDelete:false, record:null})
        }

        const deleteButtons = () => {
            return (
            <div>
                <button onClick={() => this.setState({showDelete: false})} className='btdel'>Cancel</button>
                <button onClick={handleDelete} className='btsave'>Ok</button>
            </div>
            )
        }

    //SECTION E
        return (
            <Confirm
            height='100px'
            width='300px'
            open={this.state.showDelete} 
            data={this.state.record}
            content="Delete this Macro ?"
            title='Delete Macro'
            actions = {deleteButtons()}
            onDismiss={() => this.setState({showDelete : false, record:null})}
        />
        )
    }

}


const mapStateToProps = (state) => {
    return { 
        contents : state.selectedPatient,
        photo_macros : Object.values(state.photo_macros),
        selectedPhoto_External : state.selectedPhoto_External,
        selectedPhoto_Macro : state.selectedPhoto_Macro,
        showPhoto_Display : state.showPhoto_Display,
        patient : state.selectedPatient,
        userId : state.auth.userId,
        selectedPermission : state.selectedPermission,
    }
}

export default connect(mapStateToProps, {fetchPhotoExternal, fetchShowMacro, fetchPhotoMacros, fetchPhotoMacro, editPhotoMacro, newPhotoMacro, deletePhotoMacro})(PhotoMacro);




